import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD,
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALINSTITUTIONID,
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALID,
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_ID,
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID,

    ACTION_TRIALINSTITUTIONLABORATORY_SAVE,

    ACTION_TRIALINSTITUTIONLABORATORY_CREATE,

    ACTION_TRIALINSTITUTIONLABORATORY_DELETE,

    ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE,

    ITrialInstitutionLaboratoriesLoadAction,
    ITrialInstitutionLaboratoriesLoadByTrialInstitutionIdAction,
    ITrialInstitutionLaboratoriesLoadByTrialIdAction,
    ITrialInstitutionLaboratoryLoadByIdAction,
    ITrialInstitutionLaboratoryLoadByLaboratoryIdAction,
    ITrialInstitutionLaboratoryLoadFailureAction,
    ITrialInstitutionLaboratoryLoadSuccessAction,

    ITrialInstitutionLaboratorySaveAction,
    ITrialInstitutionLaboratorySaveSuccessAction,
    ITrialInstitutionLaboratorySaveFailureAction,

    ITrialInstitutionLaboratoryCreateAction,
    ITrialInstitutionLaboratoryCreateSuccessAction,
    ITrialInstitutionLaboratoryCreateFailureAction,

    ITrialInstitutionLaboratoryDeleteAction,
    ITrialInstitutionLaboratoryDeleteSuccessAction,
    ITrialInstitutionLaboratoryDeleteFailureAction,

    ITrialInstitutionLaboratoryValidateAction,
    ITrialInstitutionLaboratoryValidateSuccessAction,
    ITrialInstitutionLaboratoryValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    DeleteSuccess,
    DeleteFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialInstitutionLaboratory";
import { trialInstitutionLaboratoryApi } from "../services/trialInstitutionLaboratory";


export const
    getTrialInstitutionLaboratoriesEpic = (action$): Observable<ITrialInstitutionLaboratoryLoadSuccessAction | ITrialInstitutionLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORY_LOAD)
            .mergeMap((_action: ITrialInstitutionLaboratoriesLoadAction) => {
                return trialInstitutionLaboratoryApi
                    .getTrialInstitutionLaboratories()
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratories, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionLaboratoriesByTrialInstitutionIdEpic = (action$): Observable<ITrialInstitutionLaboratoryLoadSuccessAction | ITrialInstitutionLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALINSTITUTIONID)
            .mergeMap((action: ITrialInstitutionLaboratoriesLoadByTrialInstitutionIdAction) => {
                return trialInstitutionLaboratoryApi
                    .getTrialInstitutionLaboratoriesByTrialInstitutionId(action.trialInstitutionId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratories, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionLaboratoriesByTrialIdEpic = (action$): Observable<ITrialInstitutionLaboratoryLoadSuccessAction | ITrialInstitutionLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALID)
            .mergeMap((action: ITrialInstitutionLaboratoriesLoadByTrialIdAction) => {
                return trialInstitutionLaboratoryApi
                    .getTrialInstitutionLaboratoriesByTrialId(action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratories, undefined, undefined, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionLaboratoryByIdEpic = (action$): Observable<ITrialInstitutionLaboratoryLoadSuccessAction | ITrialInstitutionLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_ID)
            .mergeMap((action: ITrialInstitutionLaboratoryLoadByIdAction) => {
                return trialInstitutionLaboratoryApi
                    .getTrialInstitutionLaboratoryById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionLaboratoryByLaboratoryIdEpic = (action$): Observable<ITrialInstitutionLaboratoryLoadSuccessAction | ITrialInstitutionLaboratoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID)
            .mergeMap((action: ITrialInstitutionLaboratoryLoadByLaboratoryIdAction) => {
                return trialInstitutionLaboratoryApi
                    .getTrialInstitutionLaboratoryByLaboratoryId(action.laboratoryId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionLaboratory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialInstitutionLaboratoryEpic = (action$): Observable<ITrialInstitutionLaboratorySaveSuccessAction | ITrialInstitutionLaboratorySaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORY_SAVE)
            .mergeMap((action: ITrialInstitutionLaboratorySaveAction) => {
                return trialInstitutionLaboratoryApi
                    .setTrialInstitutionLaboratory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialInstitutionLaboratory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialInstitutionLaboratoryEpic = (action$): Observable<ITrialInstitutionLaboratoryCreateSuccessAction | ITrialInstitutionLaboratoryCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORY_CREATE)
            .mergeMap((action: ITrialInstitutionLaboratoryCreateAction) => {
                return trialInstitutionLaboratoryApi
                    .createTrialInstitutionLaboratory(action.laboratoryId, action.trialInstitutionId)
                    .map(response =>
                        CreateSuccess(response.trialInstitutionLaboratory, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    deleteTrialInstitutionLaboratoryEpic = (action$): Observable<ITrialInstitutionLaboratoryDeleteSuccessAction | ITrialInstitutionLaboratoryDeleteFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORY_DELETE)
            .mergeMap((action: ITrialInstitutionLaboratoryDeleteAction) => {
                return trialInstitutionLaboratoryApi
                    .deleteTrialInstitutionLaboratory(action.id)
                    .map(_response =>
                        DeleteSuccess()
                    )
                    .catch(error =>
                        Observable.of(DeleteFailure(error.responseStatus))
                    )
            });
    },
    validateTrialInstitutionLaboratoryEpic = (action$): Observable<ITrialInstitutionLaboratoryValidateSuccessAction | ITrialInstitutionLaboratoryValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE)
            .mergeMap((action: ITrialInstitutionLaboratoryValidateAction) => {
                return trialInstitutionLaboratoryApi
                    .validateTrialInstitutionLaboratory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialInstitutionLaboratory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }